module.exports = __webpack_public_path__ + "img/wt.8e3039f6.jpg";